/**
 * Restituisce la larghezza della colonna della tabella in percentuale,
 * oppure undefined se non è stata impostata.
 */
export function getTableInputColumnWidth(width: number | undefined) {
  return width ? `${width}%` : undefined;
}
